import EmailSettings from "./EmailSettings";

export default EmailSettings;
